<script>
export default {
    props: {
        labelOn: {
            type: String,
            required: false
        },

        labelOff: {
            type: String,
            required: false
        },

        colorOn: {
            type: String,
            required: false
        },

        colorOff: {
            type: String,
            required: false
        },

        thumbColor: {
            type: String,
            required: false
        },

        disabled: {
            type: Boolean,
            required: false
        },

        initialValue: {
            type: Boolean,
            required: false,
            default: false
        },

        alignItems: {
            type: String,
            required: false
        }
    },

    data() {
        return {
            switchOn: true
        }
    },

    watch: {
        initialValue(newVal) {
            this.switchOn = newVal;
        }
    },

    computed: {
        bgColor() {
            if (this.switchOn && this.colorOn) {
                return this.colorOn;
            } else if (this.switchOn && !this.colorOn) {
                return 'var(--sustainfinity-green)';
            } else if (!this.switchOn && this.colorOff) {
                return this.colorOff;
            } else if (!this.switchOn && !this.colorOff) {
                return 'whitesmoke';
            }
        }
    },

    mounted() {
        if (this.initialValue == false) {
            this.switchOn = false;
        } else if (this.initialValue == true) {
            this.switchOn = true;
        } else {
            this.switchOn = true;
        }
    },

    methods: {
        clickSwitch() {
            if (this.disabled == true) {
                return;
            }
            
            this.switchOn = !this.switchOn;
            this.$emit("buttonState", this.switchOn);
        }
    }
}
</script>

<template>
    <div class="switch-container" :style="{alignItems: alignItems}">
        <div class="switch-body" :class="{'disabled-switch-button': disabled}" @click="clickSwitch()" :style="{backgroundColor: bgColor, marginRight: alignItems == 'center' ? 0 : null}">
            <div class="switch-thumb" :class="{'switch-right': switchOn, 'switch-right-white': switchOn && !thumbColor}" :style="{backgroundColor: thumbColor ? thumbColor : null}">
                <!-- thumb -->
            </div>
        </div>
        <div v-if="switchOn && labelOn" class="switch-label">
            {{ labelOn }}
        </div>
        <div v-if="!switchOn && labelOff" class="switch-label">
            {{ labelOff }}
        </div>
    </div>
</template>

<style lang='scss' scoped>
    .switch-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: flex-start;
        align-items: flex-start;
        text-align: left;
        
        > .switch-label {
            padding-top: .2em;
            font-weight: bold;
        }
    }

    .switch-body {
        margin-right: .5em;

        width: 64px;
        height: 24px;

        border-radius: 100px;
        background-color: whitesmoke;
        outline: thin solid gray;

        cursor: pointer;
        transition: background-color 100ms;

        position: relative;
        > .switch-thumb {
            position: absolute;
            left: 2px;
            top: 50%;
            transform: translateY(-50%);
            border-radius: 100px;
            outline: thin solid gray;
            width: 20px;
            height: 20px;

            transition: all 100ms;
            background-color: var(--sustainfinity-navy);
        }

        > .switch-right {
            position: absolute;
            left: 42px;
        }

        > .switch-right-white {
            background-color: white !important;
        }
    }

    .disabled-switch-button {
        filter: grayscale(100%);
        cursor: not-allowed !important;
    }
</style>